const BanIcon = () => {
    return <i className="fa-regular fa-ban"></i>;
}

export default BanIcon;